import { userDate } from 'owa-datetime';
import { GetBoxSharingInfoResponse } from 'owa-fileprovider-link-services';
import { AnchorElementsSource } from 'owa-link-data';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import AttachmentPermissionLevel from 'owa-service/lib/contract/AttachmentPermissionLevel';
import AttachmentResultCode from 'owa-service/lib/contract/AttachmentResultCode';
import { BoxSharingInfo } from 'owa-sharing-data';
import SharingLinkInfo from '../store/schema/SharingLinkInfo';
import { LinkActionStatus } from '../types/LinkActionStatus';
import { getSharingUrls } from '../utils/getSharingUrls';
import { getSupportedPermissionLevels } from '../utils/getSupportedPermissionLevels';

export function createLinkModelForBox(
    linkId: string,
    url: string,
    response: GetBoxSharingInfoResponse | null,
    source: AnchorElementsSource,
    unwrappedUrl: string
): SharingLinkInfo {
    let sharingInfo: BoxSharingInfo;
    const responseSucceeded: boolean =
        response && response.ResultCode === AttachmentResultCode.Success;
    sharingInfo = {
        getSharingInfoSucceeded: responseSucceeded,
        canShareInternally: responseSucceeded,
        canShareExternally: responseSucceeded,
        blocksDownload: responseSucceeded ? response.BlocksDownload : false,
        expirationDate: response?.ExpirationDate ? userDate(response.ExpirationDate) : null,
        canRefresh: false,
        linkType: responseSucceeded ? response.Type : null,
        providerFileId: responseSucceeded ? response.providerFileId : null,
        location: responseSucceeded ? response.location : null,
    };

    return {
        linkId: linkId,
        providerType: AttachmentDataProviderType.Box,
        fileName: response?.FileName,
        mimeType: response?.MimeType,
        url: url,
        unwrappedUrl: unwrappedUrl,
        accessTokenAvailable: false,
        permissionLevel: AttachmentPermissionLevel.AnonymousView,
        sharingInfo: sharingInfo,
        supportedPermissionLevels: responseSucceeded
            ? getSupportedPermissionLevels(response, AttachmentDataProviderType.Box)
            : null,
        sharingUrls: responseSucceeded ? getSharingUrls(response) : null,
        sharingTipsIgnored: [],
        sharingRecipientsInfo: { recipientPermissionInfos: [] },
        linkActionStatus: LinkActionStatus.none,
        source: source,
    };
}
